export default {
  cancelButtonLabel: 'CANCEL',
  contentInputCaption: '%count% characters left.',
  contentInputLabel: 'Content',
  nameInputLabel: 'Name',
  submitButtonLabel: 'SAVE',
  title: 'Edit Message Template'
};
